import es from './es.json';
import en from './en.json';

const LANGS = { es, en };

function getBrowserLang() {
  const lang = navigator.language || navigator.languages[0] || 'en';
  if (lang.startsWith('es')) return 'es';
  return 'en';
}

function getPathLang(): 'es' | 'en' | null {
  const path = window.location.pathname;
  if (path.startsWith('/en')) return 'en';
  if (path === '/' || path.startsWith('/proyectos') || path.startsWith('/equipo') || path.startsWith('/contacto')) return 'es';
  return null;
}

export function getLang(): 'es' | 'en' {
  // First check the URL path
  const pathLang = getPathLang();
  if (pathLang) return pathLang;
  
  // Then check localStorage
  const stored = localStorage.getItem('lang');
  if (stored === 'es' || stored === 'en') return stored;
  
  // Finally, fall back to browser language
  return getBrowserLang();
}

export function setLang(lang: 'es' | 'en') {
  localStorage.setItem('lang', lang);
  // Forzar recarga de la página con la nueva ruta
  const currentPath = window.location.pathname;
  let newPath = '/';

  if (lang === 'en') {
    // Convertir a rutas en inglés
    if (currentPath === '/') newPath = '/en/home';
    else if (currentPath === '/proyectos') newPath = '/en/projects';
    else if (currentPath === '/equipo') newPath = '/en/team';
    else if (currentPath === '/contacto') newPath = '/en/contact';
  } else {
    // Convertir a rutas en español
    if (currentPath === '/en') newPath = '/';
    else if (currentPath === '/en/projects') newPath = '/proyectos';
    else if (currentPath === '/en/team') newPath = '/equipo';
    else if (currentPath === '/en/contact') newPath = '/contacto';
  }

  window.location.href = newPath;
}

export const lang = LANGS[getLang()]; 